<script lang="ts">
  export let fill: string = "yellow";
  export let wbgtValue: number = 84;
  export let radius: string = "6";
  let totalCircumference: number = 2 * Math.PI * parseInt(radius);
  

  const maxDegrees = 160;
  const wbgtScaleMin = 70;
  const wbgtScaleMax = 98;
  let rotate = maxDegrees * ((wbgtValue - wbgtScaleMin) / (wbgtScaleMax - wbgtScaleMin));
  if(wbgtValue < 70){
    rotate = 10;
  }
</script>

<div class="svg-box">
  <svg class="svg-content" style="--rotate: {rotate}" width="100%" height="100%" viewBox="-8 -8 16 16">

    <defs>
      <clipPath id="clip-bot">
        <rect x="-50%" y="-50%" height="50%" width="100%"  />
        
      </clipPath>
    </defs>

    <circle class="timer-base" r={radius} clip-path="url(#clip-bot)"/>
    <g clip-path="url(#clip-bot)">
      <circle
      class="progress-bar"
      r={radius}
      style="stroke-dasharray: {totalCircumference}; stroke-dashoffset: {totalCircumference /
        2}; stroke: {fill}; rotate: {rotate}deg;"
      />
      <circle
      class="progress-circle"
      r="2px"
      transform="translate(-{radius} 0)"
      style="rotate: {rotate}deg;"
      {fill}
      />
    </g>
    
  </svg>
</div>
<style>
    @keyframes animateProgress {
    0% {
      rotate: var(--rotate);
    }
    100% {
      rotate: 0;
    }
  }

  .svg-content > g, .svg-content > circle {
    transform: translateY(25%);
  }
  
  .progress-bar {
    stroke-width: 2px;
    fill: transparent;
    animation: animateProgress 1s forwards;
  }

  .progress-circle{
    animation: animateProgress 1s forwards;
  }

  .timer-base {
    stroke: rgba(145, 142, 142, 0.699);
    stroke-width: 2px;
    fill: transparent;
  }
  
</style>
